import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { AttendContactLeaveEarlyJson } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import LeaveEarlyInfo from '@/domain/attendContact/component/LeaveEarlyInfo';

/**
 * プロパティ
 */
export type DetailLeaveEarlyInput = {
  /** データ */
  data: AttendContactLeaveEarlyJson | undefined,
  /** 閉じる */
  close: () => void,
}

const DetailLeaveEarly: React.FC<DetailLeaveEarlyInput> = ({ data, close }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => close()}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="早退連絡" />
    <DialogContent>
      {data && <LeaveEarlyInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => close()} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default DetailLeaveEarly;
